import Toggle from "@resources/js/ui/Toggle";

if (document.querySelector('.js-lang-toggle-btn'))
    new Toggle('.js-lang-toggle-btn', { target: '.js-lang-dropdown' })
